import { Typography } from "@mui/joy";
import React, { useEffect, useState } from "react";
import { useSiteContext } from "../../../context/siteContext";
import SiteCalenderView from "../Views/Calender";
import useApiService from "../../../hooks/useApiService";
import { RouteComponentProps } from "../../../models/RouteComponent";

export default function SiteSchedule(props: RouteComponentProps) {
  const session = props.session;
  const siteId = session?.site_id;
  const [schedule, setSchedule] = useState<any>(null);

  const { data, loading: loadingEquipment } = useApiService<any>({
    method: "GET",
    url: `site-list/${siteId}`,
    apiName: "core",
    onSuccess(data) {
      setSchedule(data.default_schedule);
    },
  });

  useEffect(() => {
    props.setGlobalLoader(loadingEquipment);
  }, [loadingEquipment]);

  return (
    <>
      <Typography level="h2" component="h1">
        Schedule: {data?.name}
      </Typography>
      <SiteCalenderView defaultSchedule={schedule} site_id={siteId || ""} />
    </>
  );
}
